import React, { useContext, useEffect, useState } from "react";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/en-gb';
import "./rcaCustom.css";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import ChartLoader from "../../Dashboard/Charginganalysis/ChartLoader";
import WaterMark from "../DashboardMain_Bus/WaterMark";

export default function RcaChartB(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  // code for multi chart with multi axis with comman zoom
  /**
  * ---------------------------------------
  * This demo was created using amCharts 5.
  * 
  * For more information visit:
  * https://www.amcharts.com/
  * 
  * Documentation is available at:
  * https://www.amcharts.com/docs/v5/
  * ---------------------------------------
  */

  // Create root element
  // https://www.amcharts.com/docs/v5/getting-started/#Root_element

  const [chartData, setChartData] = useState([])
  const [orgChartData, setorgChartData] = useState([])
  const getLineRes = (data) => {
    setorgChartData(data)
  }

  const dateTimeConverter = (arr, side, ecuLegend, signalLegend) => {
    var output = arr.map((s, index) => (
      { "date": new Date(s.sort[0]).setMinutes(new Date(s.sort[0]).getMinutes() - 330), "value": s.fields.hasOwnProperty(signalLegend) ? Number(s.fields[signalLegend]) : null }
    ));
    return { output, side, ecuLegend, signalLegend };
  }

  useEffect(() => {
    var output = orgChartData.map((s, index) => (
      dateTimeConverter(s["hugeArray"], s["side"], s["ecuLegend"], s["signalLegend"])
    ));
    setChartData(output);
  }, [orgChartData])

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "rca/getLineData", body: { filterdata: props.filterObject, SelectedLoop: props.dataChoosedB } }, getLineRes)
  }, [props.dataChoosedB])

  useEffect(() => {
    if (chartData.length > 0) {
      var root = am5.Root.new(props.id);

      // Set themes
      // https://www.amcharts.com/docs/v5/concepts/themes/
      root.setThemes([
        am5themes_Animated.new(root)
      ]);

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/xy-chart/
      var chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          focusable: true,
          panX: true,
          panY: true,
          wheelX: "panX",
          wheelY: "zoomX",
          pinchZoomX: true
        })
      );

      chart.get("colors").set("step", 3);

      // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
      var xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          maxDeviation: 0.1,
          groupData: false,
          tooltipDateFormat: "HH:mm:ss MMM dd, yyyy",
          baseInterval: { timeUnit: "second", count: 1 },
          renderer: am5xy.AxisRendererX.new(root, {}),
          tooltip: am5.Tooltip.new(root, {})
        })
      );
      xAxis.get("dateFormats")["day"] = "yyyy-MM-dd HH:mm:ss"
      // Add cursor
      // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
      var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
        xAxis: xAxis,
        behavior: "none"
      }));
      cursor.lineY.set("visible", false);

      // add scrollbar
      chart.set("scrollbarX", am5.Scrollbar.new(root, {
        orientation: "horizontal"
      }));

      let lastI = chartData.length - 1;
      console.log("chartData___B", chartData);
      for (let i = 0; i < chartData.length; i++) {
        const element = chartData[i];
        if (element["side"] == "left") {
          (lastI === i) ? createAxisAndSeries(element["output"], false, `${element["ecuLegend"]} - ${element["signalLegend"]}`, true) : createAxisAndSeries(element["output"], false, `${element["ecuLegend"]} - ${element["signalLegend"]}`);
        } else {
          (lastI === i) ? createAxisAndSeries(element["output"], true, `${element["ecuLegend"]} - ${element["signalLegend"]}`, true) : createAxisAndSeries(element["output"], true, `${element["ecuLegend"]} - ${element["signalLegend"]}`)
        }
      }

      chart.appear(1000, 100);
      root._logo.dispose();
      return () => root.dispose();

      function createAxisAndSeries(startValue, opposite, Series, test = false) {
        var yRenderer = am5xy.AxisRendererY.new(root, {
          opposite: opposite
        });
        var yAxis = chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            maxDeviation: 1,
            renderer: yRenderer
          })
        );

        if (chart.yAxes.indexOf(yAxis) > 0) {
          yAxis.set("syncWithAxis", chart.yAxes.getIndex(0));
        }

        // Add series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        var series = chart.series.push(
          am5xy.LineSeries.new(root, {
            name: "Sales",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "value",
            valueXField: "date",
            legendLabelText: Series,
            legendRangeLabelText: Series,
            tooltip: am5.Tooltip.new(root, {
              pointerOrientation: "horizontal",
              labelText: "{valueY}"
            }),
          })
        );

        series.strokes.template.setAll({ strokeWidth: 1 });

        series.bullets.push(function () {
          var graphics = am5.Circle.new(root, {
            radius: 4,
            interactive: true,
            cursorOverStyle: "ns-resize",
            stroke: series.get("stroke"),
            fill: am5.color(0xffffff)
          });

          return am5.Bullet.new(root, {
            sprite: graphics
          });
        });

        yRenderer.grid.template.set("strokeOpacity", 0.05);
        yRenderer.labels.template.set("fill", series.get("fill"));
        yRenderer.setAll({
          stroke: series.get("fill"),
          strokeOpacity: 1,
          opacity: 1
        });

        // Set up data processor to parse string dates
        // https://www.amcharts.com/docs/v5/concepts/data/#Pre_processing_data
        series.data.processor = am5.DataProcessor.new(root, {
          dateFormat: "yyyy-MM-dd",
          dateFields: ["date"]
        });

        if (test) {
          let legend = chart.topAxesContainer.children.push(am5.Legend.new(root, {
            width: am5.percent(100),
            x: am5.percent(100),
            centerX: am5.percent(100),
            layout: am5.GridLayout.new(root, {
              maxColumns: 3,
              fixedWidthGrid: false
            })
          }));
          legend.data.setAll(chart.series.values);
        }
        series.data.setAll(startValue);
      }
    }

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/

  }, [chartData])

  return (
    <>
      <WaterMark />
      {
        (isLoading) ? <ChartLoader /> :
          <div id={props.id} style={{ width: "100%", height: "350px" }}></div>
      }
    </>
  );
}